import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { I18nModule } from '../../../../../core/i18n';
import { TinyCart } from '../../../../../core/model';
import { RoutingHelperService } from '../../../../../core/routing';
import { CART_TYPE_PARAM_KEY, DrawerService } from '../../../../../shared';
import { BadgeModule } from '../../../../../shared/components/badge';
import { TinyMultipleCartBadgeModule } from '../../../../../shared/components/tiny-cart-badge/tiny-multiple-cart-badge.module';
import { TinyCartFacade } from '../../../../cart/base';
import { CartDrawerModule } from '../../../../cart/containers/cart-drawer/cart-drawer.module';
import { HeaderNavigationItemModule } from '../../../components/header-navigation-item';

@Component({
  selector: 'py-menu-cart-authenticated',
  templateUrl: './menu-cart-authenticated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./menu-cart-authenticated.component.scss'],
  imports: [
    CommonModule,
    I18nModule,
    NzIconModule,
    HeaderNavigationItemModule,
    TinyMultipleCartBadgeModule,
    BadgeModule,
    CartDrawerModule,
  ],
})
export class MenuCartAuthenticatedComponent implements OnInit {
  @ViewChild('cartDrawer') cartDrawerTemplate: TemplateRef<any>;

  numberOfEntries$: Observable<number>;
  hasMultipleCarts$: Observable<boolean>;

  constructor(
    private drawerService: DrawerService,
    private tinyCartService: TinyCartFacade,
    private activatedRoute: ActivatedRoute,
    private routingService: RoutingService,
    private routingHelperService: RoutingHelperService
  ) {}

  ngOnInit() {
    this.hasMultipleCarts$ = this.tinyCartService.hasMultipleCarts();

    this.numberOfEntries$ = this.tinyCartService.getTinyCarts().pipe(
      map((tinyCarts) => tinyCarts || []),
      map((tinyCarts) => {
        let totalNumberOfEntries = 0;
        tinyCarts.forEach((tinyCart) => (totalNumberOfEntries += tinyCart?.numberOfEntries || 0));
        return totalNumberOfEntries;
      })
    );
  }

  @HostListener('click')
  onClick() {
    // While user is on Checkout page or Cart page, redirect to Cart page instead of opening tiny cart (so when on Cart page, nothing will happen)
    if (
      this.routingHelperService.getCurrentUrlWithoutParams() === '/checkout' ||
      this.routingHelperService.getCurrentUrlWithoutParams() === '/cart'
    ) {
      const cartTypeParam = this.activatedRoute.snapshot.queryParamMap.get(CART_TYPE_PARAM_KEY);
      this.routingService.go({ cxRoute: 'cart' }, { queryParams: { [CART_TYPE_PARAM_KEY]: cartTypeParam } });
    } else {
      this.drawerService
        .open({
          template: this.cartDrawerTemplate,
          wrapClassName: 'tiny-cart-drawer-wrapper',
        })
        .pipe(take(1))
        .subscribe();
    }
  }

  trackByFn(_index, tinyCart: TinyCart) {
    return tinyCart.code;
  }
}
